import styled, { css } from 'styled-components';

const ComparePlansRowStyled = styled.section.attrs({
  className: 'accordion',
})`
  ${({ theme }) => {
    const { colors, fonts, media } = theme;
    return css`
      background-color: ${colors.primary.white};
      position: relative;
      .cp-row {
        &__wrapper {
          display: flex;
          padding: 8px 16px 16px 16px;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 16px;
          align-self: stretch;
        }

        &__header {
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
          align-self: stretch;
          span {
            color: ${colors.primary.gravity};
          }
          ${media.mobile.down} {
            font-size: 14px;
            line-height: 20px;
          }
        }

        &__content {
          display: flex;
          align-items: center;
          gap: 16px;
          align-self: stretch;
        }

        &__item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex: 1 0 0;
        }

        &__item-title {
          font-size: 30px;
          font-style: normal;
          font-weight: 500;
          line-height: 34px;
          align-self: stretch;
          span {
            color: ${colors.primary.gravity};
          }
          ${media.mobile.down} {
            font-size: 24px;
            line-height: 28px;
          }
        }
        &__item-description {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
          align-self: stretch;
          max-width: 100px;
          span {
            color: ${colors.primary.gravity};
            font-family: ${fonts.objectSans};
          }
          ${media.mobile.down} {
            font-size: 14px;
            line-height: 18px;
          }
        }

        &__item-icon {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1 0 0;
          align-self: stretch;
        }
      }
    `;
  }}
`;

export default ComparePlansRowStyled;
